import { render, staticRenderFns } from "./onebox-loginsharelink-tokenunavailable.vue?vue&type=template&id=2ce548a4&"
import script from "./onebox-loginsharelink-tokenunavailable.vue?vue&type=script&lang=js&"
export * from "./onebox-loginsharelink-tokenunavailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports